import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { StyledContainer, StyledContent } from './HPCAddProcess.styled';

const HPCAddProcess: React.FC = () => {
  const { t } = useI18n('hiring-process-comparison');

  return (
    <StyledContainer>
      <StyledContent>
        <Heading2 editorial alignLeft>
          {t('hiring-process-comparison.add_process.title')}
        </Heading2>
        <p>{t('hiring-process-comparison.add_process.desc')}</p>
        <ButtonLink
          href="https://form.typeform.com/to/OoHs7m3N?source=WebCTA"
          target="_blank"
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('hiring-process-comparison.add_process.cta')}</span>
        </ButtonLink>
      </StyledContent>
    </StyledContainer>
  );
};

export default HPCAddProcess;
